import React from 'react';
import Form from './Form';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const Create = () => {

    const { addData } = useEntityCrud('Branch/SetHolding');
    const navigate = useNavigate();

    const initialValues = {
        title: '',
        address: '',
        tel: ''
    };

    const validationSchema = Yup.object({
        title: Yup.string()
            .required(),
        address: Yup.string()
            .min(10, 'طول آدرس وارد شده کوتاه است')
            .required(),
        phone: Yup.string()
            .test('phone', 'شماره تلفن وارد شده معتبر نمی باشد', value => {
                return value && /^\d+$/.test(value.toString().replace('-', '')) && !value.startsWith('09') && value.length == 12;
            })
    });

    const onSubmit = (values) => {
         
        document.getElementById('btn-submit-form').classList.add('btn-loading');
        const postedData = {
            title: values.title,
            address: values.address,
            phone: values.phone
        };
        addData(postedData).then(({ data }) => {
             
            if (data.status) {
                toast.success('هلدینگ جدید با موفقیت ایجاد شد');
                return navigate('/holding');
            }
            else
                data.errors.map(error => toast.error(error.message));
        }).finally(() => document.getElementById('btn-submit-form').classList.remove('btn-loading'));
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit,
        validationSchema: validationSchema
    });

    const handleBack = () => {
        navigate('/holding', {replace: true});
    }

    return (
        <div className="card">
            <div className="card-header  d-flex justify-content-between">
                <div className="card-title">ابجاد هلدینگ جدید</div>
                <a className='backIconLink' onClick={handleBack}> <i className='fa fa-arrow-left'
                    title="بازگشت"> </i> </a>
            </div>
            <div className="card-body">
                <Form formik={formik} />
            </div>
        </div>
    );
}

export default Create;